import { automaticApi } from "@/settings/api";
import environment from "@/settings/environment";
import { clearString } from "@/utils/functions";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
  document: string;
  pin: string;
  hashCode: string;
  newPassword: string;
  callback: (success: boolean, data?: string) => void;
}

export interface ChangePasswordAction {
  type: string;
  payload: Fetch;
}

const uri = `/login-app/${environment.api?.loginVersion ?? "v1"}/alterarSenha`;

export default function* changePassword({
  payload,
}: ChangePasswordAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const data = {
      cpf: clearString(payload.document),
      pin: payload.pin,
      senhaNova: payload.newPassword,
      hsacc: payload.hashCode ?? undefined,
    };

    const response: {
      data: {
        status: {
          codigoRetorno: number;
          mensagem: string;
        };
      };
    } = yield call(automaticApi.post, uri, data);

    if (response?.data?.status?.codigoRetorno === 0) {
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
